import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../seo";
import { slugify } from "../../utils/slugify";

const LandingpageAccount = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Icon mapping function based on section title
  const getSectionIcon = (title) => {
    const iconMap = {
      "Bill Details (What's Included)": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 17.6666V13.25C17.6666 9.00996 21.0933 5.58329 25.3333 5.58329H27.6666C31.9066 5.58329 35.3333 9.00996 35.3333 13.25V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 26.5H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 33.125H28.7083"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 39.75H26.5"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "View & Manage Your Bill": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 13.25V9.9375C19.875 7.40167 21.9017 5.375 24.4375 5.375H28.5625C31.0983 5.375 33.125 7.40167 33.125 9.9375V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 29.3333V26.5"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 32.25V32.2916"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    };

    return (
      iconMap[title] || (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    );
  };

  const helpSections = [
    {
      title: "Billing and Payments",
      description:
        "Manage your xPage subscription, view bills, and understand charges",
      items: [
        {
          id: "understand-xpage",
          title: "Understand xPage",
          description:
            "Learn about xPage billing, subscription plans, and payment management.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M26.5 17.6666V26.5L31.9375 31.9375"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          sections: [
            {
              id: "Bill Details (What's Included)",
              title: "Bill Details (What's Included)",
              description:
                "Understand what charges are included in your xPage bill and how they are calculated.",
            },
            {
              id: "View & Manage Your Bill",
              title: "View & Manage Your Bill",
              description:
                "Learn how to view your billing history, manage payments, and update billing information.",
            },
          ],
        },
      ],
    },
  ];

  // Handle card click - use the exact section names from sidebar
  // Handle card click - update URL with section like sidebar (no slugs)
const handleCardClick = (itemId, sectionId) => {
  navigate(`/help/${slugify(itemId)}/${slugify(sectionId)}`);
};
  // Filter items based on search query
  const filteredSections = helpSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.sections.some(
            (sectionItem) =>
              sectionItem.title
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
              sectionItem.description
                .toLowerCase()
                .includes(searchQuery.toLowerCase()),
          ),
      ),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <div className="min-h-screen flex flex-col md:pt-10 pt-16">
      <SEO
        title="Billing and Payments – xPage Help Center"
        description="Learn how to manage your xPage subscription, view bills, and understand charges. Access detailed guides on billing details and managing payments."
        keywords="xPAGE, billing, payments, subscription, bills, help center"
        canonical="https://help.xpage.ai/help/understand-xpage/understand-xpage"
        type="article"
      />
      <div className="flex-1 w-full py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header with Description */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-systemTitle mb-3">
              Billing and Payments
            </h1>

            {/* Added description text */}
            <div className="mb-6">
              <p className="text-sm text-systemSubTitle leading-relaxed">
                Your xPage bill is a record of charges based on your landing
                pages activities, subscription plan, and services used. It
                includes details on what you need to pay, such as subscription
                fees, transaction fees, and taxes. xPage emails each bill to
                store owners so they can stay informed and pay on time. You can
                check your billing history and upcoming charges anytime in the
                xPage admin.
              </p>
            </div>
          </div>

          {/* Spacing between description and cards */}
          <div className="mb-6"></div>

          {/* Help Sections */}
          <div className="space-y-6">
            {filteredSections.map((section, sectionIndex) => (
              <div key={sectionIndex} className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {section.items.flatMap((item) =>
                    item.sections.map((sectionItem, sectionIndex) => (
                      <div
                        key={sectionIndex}
                        onClick={() => handleCardClick(item.id, sectionItem.id)}
                        className="group relative bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 cursor-pointer hover:border-systemLabel"
                      >
                        <div className="relative z-10">
                          {/* Icon and Title */}
                          <div className="flex items-center space-x-3 mb-3">
                            <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center transition-colors duration-300 group-hover:bg-deepPurple/5">
                              {getSectionIcon(sectionItem.title)}
                            </div>
                            <h3 className="text-lg font-semibold text-systemTitle transition duration-300">
                              {sectionItem.title}
                            </h3>
                          </div>

                          {/* Section-specific description */}
                          <p className="text-sm text-systemLabel leading-relaxed transition-colors duration-300">
                            {sectionItem.description}
                          </p>

                          {/* Hover arrow indicator */}
                          <div className="absolute right-4 top-4 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                            <svg
                              className="w-7 h-7 text-base"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    )),
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingpageAccount;
